export default __webpack_public_path__ + "073bce0af237ea71592649f1ce22ea02.png";